//------------------------------------------------------------------------
// Import Existing Global-nav.js 
//------------------------------------------------------------------------
require('../ENTPh2/core/js/global-nav.js');

//All document ready
$(document).ready(function () {
    //------------------------------------------------------------------------
    // Popup script from bell.js 
    //------------------------------------------------------------------------
    // Popup tooltips/menus
    $('.trigger-popup').on('click touch', function () {
        $('.trigger-popup').next().hide();
        $(this).next().show();
    });
    $(document).on('click touch', function (event) {
        if (!$(event.target).parents().addBack().is('.trigger-popup')) {

            $('.popup').not(this).hide();
        }
    });
    $('.popup').on('click touch', function (event) {
        event.stopPropagation();
    });

    // Start Check to see if the window is top if not then display backtotop button
    function showBacktoTopBtn() {
        var sP = $(window).outerHeight() + $(this).scrollTop();
        if (sP > $(window).outerHeight() + 100 && $(window).outerWidth() < 992) {
            $('.scrollToTop.mobile').fadeIn();
        } else {
            $('.scrollToTop.mobile').fadeOut();
        }
    }

    showBacktoTopBtn();

    $(window).resize(function () {
        showBacktoTopBtn();
    });

    $(window).scroll(function () {
        showBacktoTopBtn();
    });
    // End Check to see if the window is top if not then display backtotop button

    // Click event to scroll to top
    $('.scrollToTop').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 500);
        return false;
    });

    // Close sidemenu when clicking backdrop
    const navOpenButton = $('.connector-nav-open-button');
    navOpenButton.on('click touch', () => {
        if(!$('body').hasClass('connector-active')) {
            $('.blocker').addClass('open');
        } else {
            $('.blocker').removeClass('open');
        }
    });

    // Close mobile menu with click outside (on blocker)
    $('.blocker').on('click touch', () => {
        if($('.blocker').hasClass('open')) {
            $('body').removeClass('connector-active');
            $('.blocker').removeClass('open');
            // Switch icon hamburger menu (hamburger / X)
            navOpenButton.removeClass('active');
        } else {
            return false;
        }
    });
});